module.exports = __webpack_public_path__ + "img/pcad-analysis-views.8998020c.png";